/**
 * Shift-clicking a game while picking games: everything from the last game clicked to this one, in the order the
 * list shows them, is added to what's picked. With no earlier click, just this one.
 *
 * @param {number[]} order    the games' ids as the list shows them
 * @param {number[]} selected the ids picked so far
 * @param {number|null} from  the last game clicked
 * @param {number} to         the game shift-clicked
 */
export function selectRange(order, selected, from, to) {
  const start = order.indexOf(from);
  const end = order.indexOf(to);
  const range = start === -1 ? [to] : order.slice(Math.min(start, end), Math.max(start, end) + 1);
  return [...selected, ...range.filter(id => !selected.includes(id))];
}
